export default "__VITE_PUBLIC_ASSET__9a56d6e0__"